<template>
  <div class="clientFundsStatistics">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="form.agent" placeholder="请选择代理">
            <el-option
              v-for="item in form.agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.account" placeholder="交易账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.export')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'performanceStatistics',
    data(){
      return{
        form: {
          agent: '',
          agentData: [],
          account:"",
          startTime: new Date(),
          endTime: new Date()
        },
        tableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '二级代理数', id: 'twoLevelRatio' },
          { name: '三级代理数', id: 'threeLevelRatio' },
          { name: '总开户量', id: 'startTime' },
          { name: '总激活量', id: 'endTime' },
          { name: '入金总额', id: 'assignTradeAmount' },
          { name: '出金总额', id: 'assignLevelAmount' },
          { name: '净入金总额', id: 'assignLevelAmount' },
          { name: '交易总金额', id: 'assignAmount' },
          { name: '交易总盈亏', id: 'assignLevelAmount' },
        ],
        tableData: [],
      }
    },
    methods: {
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  .clientFundsStatistics {
    margin: 20px;

    .pop-title {
      margin-bottom: 20px;

      p {
        font-size: 16px;
        color: #409eff
      }
    }

    .total {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      p {
        display: block;
        font-size: 16px;
        margin-right: 30px;

        &:first-child {
          margin-left: 0
        }

        em {
          display: inline;
          color: #409eff
        }
      }
    }
  }
</style>
